import React, { FC, useState, useContext, useMemo } from 'react'
import makeStyles from '@mui/styles/makeStyles';
import { getProps } from '@kaidam/fc-shared/src/frontend/components/form/fields/utils'
import LayoutWrapper from '../../layouteditor/Wrapper'
import TinyButton from '../../widgets/TinyButton'
import FormTitle from '../../widgets/FormTitle'
import {
  FormFieldProps,
} from '../../../types/form'

import Window from '../../dialog/Window'
import LayoutRender from '../../layouteditor/LayoutRender'
import LayoutFormContext from '../../layouteditor/FormContext'
import useLayoutRenderContext from '../../hooks/useLayoutRenderContext'

import {
  LAYOUT_DEFAULT_DATA,
  LAYOUT_OPTIONS_FORM,
} from '@kaidam/fc-shared/src/constants'
import icons from '../../../icons'

import {
  mergeRenderValues,
} from '@kaidam/fc-shared/src/layout/utils'

const EditIcon = icons.edit
const CancelIcon = icons.cancel

const DEFAULT_PAGE_LAYOUT = Object.assign({}, LAYOUT_DEFAULT_DATA, {
  optionsName: 'form'
})

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  toolbar: {
    width: '100%',
    flexGrow: 0,
    height: '64px',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start'
  },
  editButton: {
    marginLeft: theme.spacing(2),
  },
  content: {
    width: '100%',
    flexGrow: 1,
    border: '1px solid #ccc',
    padding: theme.spacing(1),
    minHeight: '100px',
    maxHeight: '400px',
    overflowY: 'auto',
    cursor: 'pointer',
  }
}))

const Layout: FC<React.PropsWithChildren<FormFieldProps>> = (props) => {
  const {
    field: {
      name,
      value,
    },
    form: {
      setFieldValue,
      setFieldTouched,
    },
    item,
    readonly,
  } = getProps(props)

  const title = item.title || name

  const renderContext = useLayoutRenderContext()
  const [ editing, setEditing ] = useState(false)

  const classes = useStyles()

  const formContext = useContext(LayoutFormContext)

  const useValue = useMemo(() => {
    return value || DEFAULT_PAGE_LAYOUT
  }, [
    value,
  ])

  const useRenderContext = useMemo(() => {
    const values = mergeRenderValues(useValue, formContext.renderValues)
    return Object.assign({}, renderContext, {
      disableLinks: false,
      preview: true,
      values,
    })
  }, [
    useValue,
    renderContext,
    formContext,
  ])

  const onSave = (raw: any) => {
    delete(raw.options)
    raw.optionsName = 'form'
    setFieldValue(name, raw)
    setFieldTouched(name, true)
    setEditing(false)
  }
  
  return (
    <div className={ classes.root }>
      <div className={ classes.toolbar }>
        <FormTitle
          title={ title }
        />
        {
          !readonly && (
            <TinyButton
              className={ classes.editButton }
              variant="outlined"
              color="secondary"
              startIcon={ <EditIcon /> }
              onClick={ () => setEditing(true) }
            >
              Edit
            </TinyButton>
          )
        }
        
      </div>
      <div className={ classes.content } onClick={ () => {
        if(readonly) return
        setEditing(true) 
      }}>
        {
          value && (
            <LayoutRender
              data={ value }
              context={ useRenderContext }
            />
          )
        }
      </div>
      {
        editing && (
          <Window
            open
            size="lg"
            onCancel={ () => setEditing(false) }
            noActions
            fullHeight
          >
            <LayoutWrapper
              data={ value }
              context={ useRenderContext }
              onChange={ onSave }
            >
              <TinyButton
                variant="outlined"
                startIcon={ <CancelIcon /> }
                onClick={ () => setEditing(false) }
              >
                Cancel
              </TinyButton>
            </LayoutWrapper>
          </Window>
        )
      }
    </div>
    
  )
}

export default Layout